import React from "react";
import { Skeleton, TableCell, TableRow as TableRowLoader } from "@mui/material";

/**
 * TableRowsLoader Component
 * 
 * Displays loading skeleton placeholders for datatable rows while data is being fetched.
 * Creates a grid of animated skeleton elements matching the expected table dimensions
 * to provide visual feedback during async data loading.
 * 
 * @param {Object} props - Component props
 * @param {number} props.rowsNum - Number of rows to display
 * @param {number} props.colsNum - Number of columns to display
 * @returns {JSX.Element} Grid of animated skeleton loading placeholders
 */
const TableRowsLoader = ({ rowsNum, colsNum }) => {
  return [...Array(rowsNum)].map((row, index) => (
    <TableRowLoader key={index}>
      {[...Array(colsNum)].map((col, index) => (
        <TableCell>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
      ))}
    </TableRowLoader>
  ));
};

export default TableRowsLoader;
